'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0px;\n  cursor: ', ';\n'], ['\n  padding: 0px;\n  cursor: ', ';\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  width: ', ';\n  height: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _themes = require('../../../themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SVGEl = function SVGEl(props) {
  return _react2.default.createElement('svg', props);
};
var StyledSVGEl = (0, _styledComponents2.default)(SVGEl)(_templateObject, function (props) {
  return props.onClick ? 'pointer' : 'unset';
});
var Wrapper = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var SVG = function SVG(_ref) {
  var width = _ref.width,
    height = _ref.height,
    onClick = _ref.onClick,
    className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === undefined ? _themes.theme.colors.clear : _ref$color;
  return _react2.default.createElement(Wrapper, {
    width: width,
    height: height,
    className: className
  }, _react2.default.createElement(StyledSVGEl, {
    onClick: onClick,
    width: '100%',
    height: '100%',
    viewBox: '0 0 100 100'
  }, _react2.default.createElement('g', {
    transform: 'rotate(0 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.875s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(45 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.75s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(90 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.625s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(135 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.5s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(180 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.375s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(225 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.25s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(270 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '-0.125s',
    repeatCount: 'indefinite'
  }))), _react2.default.createElement('g', {
    transform: 'rotate(315 50 50)'
  }, _react2.default.createElement('rect', {
    x: '47',
    y: '22',
    rx: '7.5200000000000005',
    ry: '3.52',
    width: '6',
    height: '16',
    fill: color
  }, _react2.default.createElement('animate', {
    attributeName: 'opacity',
    values: '1;0',
    keyTimes: '0;1',
    dur: '1s',
    begin: '0s',
    repeatCount: 'indefinite'
  })))));
};
SVG.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  color: _propTypes2.default.string
};
exports.default = SVG;